<div class="row pb-2">
    <div class="col-md-6 headPortion pl-2">
        <h4 class="mb-0">Build a New Petition</h4>
        <div class="settingsPortion pl-2" (click)="onClickSettings()">
            <mat-icon>settings</mat-icon><span>Settings</span>
        </div>
    </div>
    <div class="col-md-6 pl-2">
        <button mat-stroked-button color="primary" class="pull-right" (click)="updateWizard()">ADD DETAILS</button>
    </div>
</div>
<div class="wixard-flex" *ngIf="(immigrationWizardService.selectedUploadTypes | async) as selectedUploadTypes">
    <div class="side-menu-flex card card-min no-border border-left px-2 side-nav leftMenuPortion"
        [ngClass]="{'menu-collapse': leftPanelCollapsed }">
        <span class="leftMenuPortion-collapse pi"
            [ngClass]="{'pi-angle-double-left': !leftPanelCollapsed, 'pi-angle-double-right': leftPanelCollapsed }"
            (click)="leftPanelCollapsed = !leftPanelCollapsed"></span>
        <ng-container *ngFor="let selectedType of selectedUploadTypes; let i = index;">
            <button mat-button
                class="bg-transparent text-left side-nav-btn border-top-0 border-left-0 border-right-0 border-bottom"
                routerLinkActive="activated" routerLink="{{selectedType.route}}"><span
                    class="wizard-tab-serial-number">{{ i + 1
                    }}</span><span class="wizard-tab-text"
                    *ngIf="!leftPanelCollapsed">{{selectedType.linkLabel}}</span></button>
        </ng-container>
    </div>
    <div class="content-flex bordered-panel bg-white">
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>